import BaseNormalizer from "./BaseNormalizer";

const unpublishedProductPreviewNormalizer = Object.create(BaseNormalizer).init([
  "ageRestriction",
  "alcoholContent",
  "brand",
  "certificates",
  "depositType",
  "depositValue",
  "dimensionHeightCm",
  "dimensionLengthCm",
  "dimensionWidthCm",
  "ean",
  "generalInformation",
  "grossPrice",
  "gtin",
  "id",
  "images",
  "isBio",
  "isGlutenFree",
  "isLactoseFree",
  "isOfferingFreeSamples",
  "isSubjectToCooling",
  "minimumShelfLifeDays",
  "name",
  "option",
  "packaging",
  "productCategoryId",
  "productVariantName",
  "purchasePrice",
  "quantity",
  "regulatedOrganicProductId",
  "salesQuantity",
  "salesUnit",
  "suDepositType",
  "suDepositValue",
  "suDimensionHeightCm",
  "suDimensionLengthCm",
  "suDimensionWidthCm",
  "suGtin",
  "suPackaging",
  "suQuantity",
  "suSupplierItemNumber",
  "suWeightExclPackagingKg",
  "suWeightKg",
  "supplierItemNumber",
  "vatRate",
  "weightExclPackagingKg",
  "weightGrams",
  "weightKg",
]);

export default unpublishedProductPreviewNormalizer;
